import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { SvgIconComponent } from '@app/shared/components/svg-icon/svg-icon.component'
import {
    SHIKSHA_DASHBOARD_SUBTITLE_HEADER_UI,
    ShikshaDashboardSubtitleHeaderIconSize,
} from '../constants/shiksha-dashboard.constants'

@Component({
    selector: 'app-shiksha-dashboard-subtitle-header',
    standalone: true,
    imports: [SvgIconComponent],
    templateUrl: './shiksha-dashboard-subtitle-header.component.html',
    styleUrl: './shiksha-dashboard-subtitle-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShikshaDashboardSubtitleHeaderComponent {
    readonly subtitleHeaderUi = SHIKSHA_DASHBOARD_SUBTITLE_HEADER_UI
    readonly title = input.required<string>()
    readonly subtitle = input<string | undefined>(undefined)
    readonly showInfo = input(true)
    readonly rightTitle = input<string | undefined>(undefined)
    readonly rightSubtitle = input<string | undefined>(undefined)
    readonly showDivider = input(true)
    readonly iconName = input<string | undefined>(undefined)
    readonly iconVariant = input<'default' | 'alert' | 'error' | 'warning' | 'success' | 'info'>(
        'default',
    )
    readonly iconSize = input<ShikshaDashboardSubtitleHeaderIconSize>(
        SHIKSHA_DASHBOARD_SUBTITLE_HEADER_UI.defaultIconSize,
    )
}
